/* eslint-disable */

class TabbedInterface {
    constructor() {
        this.resizeTimer = null;
        this.resizeTimerDuration = 100;
        this.mediaQuery = '(min-width: 768px)';
        this.instances = document.querySelectorAll('[data-progressive-enhancement="off"][data-progressive-enhancement-type="tabbed-interface"]');
        this.tabbedInterfacesStatus = null;
        this.orientation = null;
    }

    init(helpers) {
        const self = this;

        self.helpers = helpers;

        if (!self.instances.length) {
            return;
        }

        if (window.matchMedia(self.mediaQuery).matches) {
            self.orientation = 'horizontal';
        } else {
            self.orientation = 'vertical';
        }

        self.enhanceAll(self);

        window.addEventListener('resize', () => {
            clearTimeout(self.resizeTimer);
            self.resizeTimer = setTimeout(() => {
                self.resizeHandler(self.mediaQuery, self);
            }, self.resizeTimerDuration);
        });

        window.addEventListener('keydown', self.keyboardHandler);

        window.addEventListener('load', function() {
            const searchParams = new URLSearchParams(window.location.search);

            let selected;

            if(!searchParams.has('selected')) {
                return;
            }

            selected = searchParams.get('selected');

            selected = selected.split(',');

            selected.forEach(function(value) {
                let i,
                    matchingTabs = document.querySelectorAll('[role="tab"][aria-controls="' + value + '"]');

                for(i = 0; i < matchingTabs.length; i++) {
                    matchingTabs[i].click();
                    matchingTabs[i].blur();
                }
            });

            if(!location.hash) {
                return;
            }

            document.querySelector(location.hash).focus();
        });
    }

    /**
     * Click Handler
     *
     * Listens for clicks on tabs
     * and updates the view.
     *
     * @param {obj} e An Event object
     * @param {obj} self This class object
     */
    clickHandler(e, self) {
        if (e.type !== 'click') {
            return;
        }

        if (
            !e.target.hasAttribute('role')
            || 'tab' !== e.target.getAttribute('role')) {
            return;
        }

        if ('true' === e.target.getAttribute('aria-selected')) {
            return;
        }

        e.target.closest('[role="tablist"]').classList.add('input--mouse');

        self.changeTabPanel(e.target, self);

        e.target.focus();
    }

    /**
     * Enhance
     *
     * Adds JS functionality (progressive enhancements) to an instance of
     * the Tabbed Interface component. See also: Revert
     *
     * @param {obj} instance The HTMLElement Object to be enhanced
     * @param {obj} self This class object
     */
    enhance(instance, self) {
        let heading,
            i,
            pre,
            sections = instance.children,
            tabs,
            tabbedInterfaceName,
            tabbedInterfaceId,
            tabListInteractionDescription,
            tabListInteractionDescriptionImg,
            tabListInteractionDescriptionSpan,
            tabListInteractionDescriptionSpanTextContent = document.createTextNode(i18n.TabbedInterface.arrowKeysHint),
            tabList,
            tabNames = [],
            tabPanels;

        if(!sections.length) {
            return;
        }

        sections = [].slice.call(sections);

        heading = document.createElement('h2');

        pre = document.createElement('pre');
        
        tabList = document.createElement('div');

        tabList.setAttribute('role', 'tablist');

        tabListInteractionDescription = document.createElement('div');
        tabListInteractionDescription.id = 'tablist-interaction-description--first-tabpanel--' + sections[0].id;
        tabListInteractionDescription.setAttribute('aria-hidden', 'true');
        tabListInteractionDescription.className = 'tablist__interaction-description';

        tabListInteractionDescriptionImg = document.createElement('img');

        tabListInteractionDescriptionImg.src = '/app/themes/study-ontario-canada/dist/images/illustration--arrow-keys.svg';

        tabListInteractionDescriptionImg.alt = '';

        tabListInteractionDescriptionImg.width = '80';

        tabListInteractionDescriptionImg.height = '62';

        tabListInteractionDescriptionImg.setAttribute('loading', 'lazy');

        tabListInteractionDescription.appendChild(tabListInteractionDescriptionImg);

        tabListInteractionDescription.appendChild(tabListInteractionDescriptionSpanTextContent);

        for(i = 0; i < sections.length; i++) {
            let attributes,
                children,
                section = sections[i],
                separator = document.createElement('span'),
                separatorTextContent = document.createTextNode(' | '),
                tab,
                tabPanel,
                tabTextContent;

            if('SECTION' !== section.tagName) {
                return;
            }

            if(!section.id) {
                return;
            }

            if('' === section.id) {
                return;
            }

            if(!section.hasAttribute('aria-labelledby')) {
                return;
            }

            if('' === section.getAttribute('aria-labelledby')) {
                return;
            }

            if(!section.parentElement.querySelector('section#' + section.id + ' > ' + 'h2#' + section.getAttribute('aria-labelledby'))) {
                return;
            }

            section = self.helpers.changeHeadingLevels(section, section.querySelector('#' + section.getAttribute('aria-labelledby')).tagName.substring(1), 3);

            separator.appendChild(separatorTextContent);

            tabPanel = self.helpers.changeHTMLTag(section, 'DIV');

            tabPanel.setAttribute('role', 'tabpanel');

            tabPanel.setAttribute('tabindex', '-1');

            tab = document.createElement('button');

            tab.setAttribute('type', 'button');

            tab.setAttribute('role', 'tab');
            
            tab.setAttribute('aria-describedby', tabListInteractionDescription.id);

            tab.setAttribute('aria-controls', tabPanel.id);

            tabTextContent = tabPanel.querySelector('#' + tabPanel.getAttribute('aria-labelledby')).textContent;

            tabTextContent = tabTextContent.trim();

            if(0 < i) {
                pre.appendChild(separator.cloneNode(true));
            }

            tab.appendChild(document.createTextNode(tabTextContent));

            pre.appendChild(tab);

            tabNames.push(tabTextContent);
        }

        tabList.appendChild(pre);
        tabList.appendChild(tabListInteractionDescription);

        instance.insertBefore(tabList, instance.children[0]);

        tabs = tabList.querySelectorAll('[role="tab"]');

        tabPanels = instance.querySelectorAll('[role="tabpanel"]');

        for (i = 0; i < tabs.length; i++) {
            let tab = tabs[i],
                indicator;

            if (0 === i) {
                tab.setAttribute('tabindex', '0');
                tab.setAttribute('aria-selected', 'true');

                indicator = document.createElement('i');
                indicator.className = 'visually-hidden';
                indicator.setAttribute('aria-hidden', 'true');
                indicator.appendChild(document.createTextNode('Selected: '));
                tab.insertBefore(indicator, tab.firstChild);
            } else {
                tab.setAttribute('tabindex', '-1');
                tab.setAttribute('aria-selected', 'false');
            }

            tab.setAttribute('aria-controls', tabPanels[i].id);
        }

        for (i = 0; i < tabPanels.length; i++) {
            if (0 === i) {
                self.helpers.accessibleShow(tabPanels[i]);
            } else {
                self.helpers.accessibleHide(tabPanels[i]);
            }
        }

        tabbedInterfaceName = i18n.TabbedInterface.tabbedInterface + ' (' + tabNames.join(', ') + ')';

        tabbedInterfaceId = self.helpers.sanitizeTitle(i18n.TabbedInterface.tabbedInterface + '--');

        tabNames.forEach(function(name) {
            tabbedInterfaceId += '-' + self.helpers.sanitizeTitle(name);
        });

        instance = self.helpers.changeHTMLTag(instance, 'SECTION');

        instance.id = tabbedInterfaceId;
        
        instance.setAttribute('aria-labelledby', tabbedInterfaceId + '__heading');

        heading.id = tabbedInterfaceId + '__heading';

        heading.classList.add('visually-hidden');

        heading.appendChild(document.createTextNode(tabbedInterfaceName));

        instance.insertBefore(heading, instance.childNodes[0]);

        instance.dataset.progressiveEnhancement = 'on';

        return instance;
    }

    enhanceAll(self) {
        if (self.tabbedInterfacesStatus !== 'on') {
            for (let i = 0; i < self.instances.length; i++) {
                let currentInstance = self.instances[i],
                    tabList;

                currentInstance = self.enhance(self.instances[i], self);
                tabList = currentInstance.querySelector('[role="tablist"]');
                currentInstance.dataset.tabListOrientation = self.orientation;

                tabList.addEventListener('click', (e) => {
                    self.clickHandler(e, self);
                });

                tabList.addEventListener('mousedown', (e) => {
                   e.currentTarget.classList.add('input--mouse');
                });

                tabList.addEventListener('focusout', (e) => {
                    if(!e.currentTarget.contains(e.relatedTarget)) {
                        // Remove this class (if it exists) when focus moves outside of the tab list
                        e.currentTarget.classList.remove('input--mouse');
                    }
                    
                });
            }

            self.tabbedInterfacesStatus = true;
        }

        if(self.tabbedInterfacesStatus) {
            if(document.documentElement.dataset.progressiveEnhancements) {
                document.documentElement.dataset.progressiveEnhancements += ' tabbed-interface';
            } else {
                document.documentElement.dataset.progressiveEnhancements = 'tabbed-interface';
            } 
        }
    }

    /**
     * Query String Handler
     *
     * Listens for changes to the query
     * string and updates the view.
     *
     * @param {obj} e An Event object
     * @param {obj} self This class object
     */
    queryStringHandler(e, self) {
        e.preventDefault();

        if ('hashchange' !== e.type) {
            return;
        }

        if(document.querySelector('button[type="button"][role="tab"][aria-controls="' + location.hash.substring(1) + '"]')) {
            
            document.querySelector('button[type="button"][role="tab"][aria-controls="' + location.hash.substring(1) + '"]').click();

            history.replaceState(null, null, location.hash);
        } else {
            document.querySelector(location.hash).focus();
        }
    }

    /**
     * Keyboard Handler
     *
     * Listens for clicks on tabs
     * and updates the view.
     *
     * @param {obj} e An Event object
     * @param {obj} self This class object
     */
    keyboardHandler(e, self) {
        const currentFocus = document.activeElement;

        let firstTab,
            lastTab,
            tabs,
            tabList,
            targetTab;

        if ('keydown' !== e.type) {
            return;
        }

        if(!currentFocus.hasAttribute('role')) {
            return;
        }

        if('tab' !== currentFocus.getAttribute('role')) {
            return;
        }

        if(!currentFocus.closest('[role="tablist"]')) {
            return;
        }

        tabList = currentFocus.closest('[role="tablist"]');

        tabs = tabList.querySelectorAll('[role="tab"]');

        firstTab = tabs[0];

        lastTab = tabs[tabs.length - 1];

        switch(e.key) {
            case 'ArrowLeft':
                let previousElement;

                if(firstTab === currentFocus) {
                    targetTab = lastTab;
                } else {
                    previousElement = currentFocus.previousElementSibling;

                    while(previousElement) {
                        if('BUTTON' === previousElement.tagName) {
                            break;
                        } else {
                            previousElement = previousElement.previousElementSibling;
                        }
                    }

                    targetTab = previousElement;
                }


                break;
            case 'ArrowDown':
                currentFocus.closest('[data-progressive-enhancement-type="tabbed-interface"]').querySelector('[role="tabpanel"][tabindex="-1"]:not([hidden])').focus();

                break;
            case 'ArrowRight':
                let nextElement;

                if(lastTab === currentFocus) {
                    targetTab = firstTab;
                } else {
                    nextElement = currentFocus.nextElementSibling;

                    while(nextElement) {
                        if('BUTTON' === nextElement.tagName) {
                            break;
                        } else {
                            nextElement = nextElement.nextElementSibling;
                        }
                    }

                    targetTab = nextElement;
                }

                break;
            case 'End':
                targetTab = firstTab;

                break;
            case 'Home':
                targetTab = lastTab;
        }

        if(!targetTab) {
            return;
        }

        targetTab.click();
        tabList.classList.remove('input--mouse');
    }

    /**
     * Resize Handler
     *
     * Listens for changes to the viewport width and
     * activates/deactivates JS functionality
     * based on a media query.
     *
     * @param {string} mediaQuery The conditions
     *     required to activate the Tabbed
     *     Interface component's JS
     *     functionality
     * @param {obj} self This class object
     */
    resizeHandler(mediaQuery, self) {
        if (window.matchMedia(self.mediaQuery).matches) {
            self.orientation = 'horizontal';
        } else {
            self.orientation = 'vertical';
        }

        for (let i = 0; i < self.instances.length; i++) {
            self.instances[i].dataset.tabListOrientation = self.orientation;
        }
    }

    /**
     * Revert
     *
     * Removes JS functionality (progressive enhancements) from an instance of
     * the Tabbed Interface component. See also: Enhance
     *
     * @param {obj} instance The HTMLElement Object to be reverted
     * @param {obj} self This class object
     */
    revert(instance, self) {
        let tabList = instance.querySelector('[role="tablist"]'),
            tabPanels = instance.querySelectorAll('[role="tabpanel"]');

        instance.removeChild(tabList);

        for (let i = 0; i < tabPanels.children.length; i++) {
            const listItem = tabList.children[i];
            const tab = listItem.children[0];

            listItem.removeAttribute('role');
            tab.removeAttribute('role');
            tab.removeAttribute('tabindex');
            tab.removeAttribute('aria-selected');
            tab.removeAttribute('aria-controls');
        }

        for (let i = 0; i < tabPanels.length; i++) {
            tabPanels[i].removeAttribute('role');

            self.helpers.accessibleShow(tabPanels[i]);
        }

        instance.dataset.progressiveEnhancement = 'off';

        return instance;
    }

    changeTabPanel(targetTab, self) {
        const instance = targetTab.closest('[data-progressive-enhancement-type="tabbed-interface"]');
        const tabList = instance.querySelector('[role="tablist');
        const currentTab = tabList.querySelector('[role="tab"][tabindex="0"][aria-selected="true"]');
        const currentTabPanel = instance.querySelector('[role="tabpanel"]:not([hidden])');
        const targetTabPanel = instance.querySelector(`[role="tabpanel"][hidden]#${targetTab.getAttribute('aria-controls')}`);

        let indicator,
            searchParams,
            selected;
        
        if(currentTab.querySelector('i.visually-hidden')) {
            indicator = currentTab.removeChild(currentTab.querySelector('i.visually-hidden'));
        } else {
            indicator = document.createElement('i');
            indicator.className = 'visually-hidden';
            indicator.setAttribute('aria-hidden', 'true');
            indicator.appendChild(document.createTextNode('Selected: '));
        }

        self.helpers.accessibleHide(currentTabPanel);
        self.helpers.accessibleShow(targetTabPanel);

        currentTab.setAttribute('tabindex', '-1');
        currentTab.setAttribute('aria-selected', 'false');

        targetTab.setAttribute('tabindex', '0');
        targetTab.setAttribute('aria-selected', 'true');
        targetTab.insertBefore(indicator, targetTab.childNodes[0]);

        searchParams = new URLSearchParams(window.location.search);

        if(searchParams.has('selected')) {
            selected = searchParams.get('selected');

            selected = selected.split(',');

            selected = selected.filter(value => currentTab.getAttribute('aria-controls') !== value);

            selected = selected.filter(value => targetTab.getAttribute('aria-controls') !== value);

            selected.push(targetTab.getAttribute('aria-controls'));

            selected = selected.join(',');
        } else {
            selected = targetTab.getAttribute('aria-controls');
        }

        searchParams.set('selected', selected);

        const updatedUrl =
            window.location.protocol
            + "//"
            + window.location.host
            + window.location.pathname
            + "?"
            + searchParams.toString()
            + window.location.hash;
        window.history.replaceState(null, '', updatedUrl);
    }
}// end Class

// Singleton
export default TabbedInterface;